export enum sitePermissions {
  // Dashboard
  dashboardRead = "dashboard-read",
  dashboardUpdate = "dashboard-update",

  // Attendee
  attendeeList = "attendee-list",
  attendeeRead = "attendee-read",
  attendeeUpdate = "attendee-update",

  // Host
  hostList = "host-list",
  hostRead = "host-read",
  hostUpdate = "host-update",
  hostSubscriptionList = "host-subscribtion-list",

  // Ambassador
  ambassadorList = "ambassador-list",
  ambassadorRead = "ambassador-read",
  ambassadorUpdate = "ambassador-update",
  ambassadorRequestList = "ambassador-request-list",
  ambassadorRequestUpdate = "ambassador-request-update",

  // Minor
  minorList = "minor-list",
  minorRead = "minor-read",
  minorUpdate = "minor-update",

  // RSVPs
  rsvpList = "rsvp-list",
  rsvpRead = "rsvp-read",
  rsvpUpdate = "rsvp-update",

  // Communities
  communitiesList = "communities-list",
  communitiesRead = "communities-read",

  // Business Management
  businessList = "business-list",
  businessRead = "business-read",
  businessUpdate = "business-update",

  // Experiences
  experiencesList = "experiences-list",
  experiencesRead = "experiences-read",

  // Event Badges
  eventBadgeCreate = "event-badge-create",
  eventBadgeList = "event-badge-list",
  eventBadgeUpdate = "event-badge-update",

  // Achievement Badges
  achievementBadgeCreate = "achievement-badge-create",
  achievementBadgeList = "achievement-badge-list",
  achievementBadgeUpdate = "achievement-badge-update",

  // Core Concept Badges
  coreConceptBadgeCreate = "core-concept-badge-create",
  coreConceptBadgeList = "core-concept-badge-list",
  coreConceptBadgeUpdate = "core-concept-badge-update",

  // Resource Library
  resourceLibraryCreate = "resource-library-create",
  resourceLibraryList = "resource-library-list",
  resourceLibraryUpdate = "resource-library-update",

  // Policy & Agreement
  policyAgreementList = "policy-agreement-list",
  policyAgreementUpdate = "policy-agreement-update",

  // Cup of Gratitude
  cupOfGratitudeCreate = "cup-of-gratitude-create",
  cupOfGratitudeList = "cup-of-gratitude-list",
  cupOfGratitudeUpdate = "cup-of-gratitude-update",

  // Team Members
  teamMembersCreate = "team-members-create",
  teamMembersList = "team-members-list",
  teamMembersRead = "team-members-read",
  teamMembersUpdate = "team-members-update",

  // Role Management
  roleManagementCreate = "role-management-create",
  roleManagementList = "role-management-list",
  roleManagementRead = "role-management-read",
  roleManagementUpdate = "role-management-update",

  // Product Items
  productItemsCreate = "product-items-create",
  productItemsList = "product-items-list",
  productItemsUpdate = "product-items-update",

  // Order Requests
  orderRequestsList = "order-requests-list",
  orderRequestsRead = "order-requests-read",
  orderRequestsUpdate = "order-requests-update",
}
